import { useEffect, useState } from "react";
import { Outlet, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import Header from "../containers/Header";
import MainLayout from "../layouts/MainLayout";
import Footer from "../containers/Footer";

import { Button, Container, Spinner } from "react-bootstrap";

import { fetchInsurrance } from "../apis";

const DOMPurify = require("dompurify")(window);

function Insurrance() {
  const [insurrance, setInsurrance] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const params = useParams();
  const history = useNavigate();

  const onFetchInsurrance = async () => {
    const langCode = cookies.get("i18next");
    const json = await fetchInsurrance(params.slug, langCode);

    if (json) {
      setInsurrance(json);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    onFetchInsurrance();
  }, [params]);

  const { t } = useTranslation();

  if (isLoading) {
    return (
      <Spinner animation="grow" role="status" variant="primary">
        <span className="visually-hidden">Chargement...</span>
      </Spinner>
    );
  } else {
    return (
      <div className="">
        <Header caption={insurrance.name} bgImg={insurrance.image} />
        <MainLayout pageCSS="insurrance-page">
          <Container>
            <h2 className="">Description</h2>
            <div
              className="container insurrance-page__main-text"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(insurrance.description),
              }}
            ></div>
            <div className="text-center u-mt-medium u-mb-big">
              <Button
                className="btn-blue btn-shadow"
                onClick={() => history("book/", { replace: true })}
              >
                {t("make_a_reservation_button")}
              </Button>
            </div>
          </Container>
        </MainLayout>
        <Footer />
        <Outlet />
      </div>
    );
  }
}

export default Insurrance;
